/**
 * Locks document scroll while the mobile facet filter drawer is open.
 * Used on Graphene collection/search PLPs where overflow classes alone are insufficient.
 */
(function () {
  let savedScrollY = 0;
  let preventHandler = null;

  const LOCK_CLASS = 'facet-filters-drawer-open';
  const LOCKED_CLASS = 'is-facet-drawer-scroll-locked';
  const MOBILE_OVERFLOW_CLASS = 'overflow-hidden-mobile';

  const getDisclosure = () =>
    document.querySelector('menu-drawer.mobile-facets__wrapper .mobile-facets__disclosure') ||
    document.querySelector('.mobile-facets__wrapper .mobile-facets__disclosure');

  const isScrollAllowedTarget = (target) =>
    Boolean(
      target?.closest?.(
        '.mobile-facets__wrapper, .mobile-facets, .mobile-facets__inner, .mobile-facets__main, .mobile-facets__submenu'
      )
    );

  const preventBackgroundScroll = (event) => {
    if (!document.body.classList.contains(LOCK_CLASS)) return;
    if (isScrollAllowedTarget(event.target)) return;
    event.preventDefault();
  };

  const removeHiddenHeaderClass = () => {
    document.querySelector('.section-header')?.classList.remove('shopify-section-header-hidden');
  };

  const isFacetFiltersDrawerOpen = () => {
    const disclosure = getDisclosure();
    return Boolean(
      disclosure &&
      (disclosure.hasAttribute('open') || disclosure.classList.contains('menu-opening'))
    );
  };

  const applyLock = () => {
    savedScrollY = window.scrollY;

    document.documentElement.classList.add(LOCK_CLASS, LOCKED_CLASS, MOBILE_OVERFLOW_CLASS);
    document.body.classList.add(LOCK_CLASS, LOCKED_CLASS, MOBILE_OVERFLOW_CLASS);

    document.body.style.setProperty('position', 'fixed', 'important');
    document.body.style.setProperty('top', `0`, 'important');
    document.body.style.setProperty('left', '0', 'important');
    document.body.style.setProperty('right', '0', 'important');
    document.body.style.setProperty('width', '100%', 'important');

    if (!preventHandler) {
      preventHandler = preventBackgroundScroll;
      document.addEventListener('wheel', preventHandler, { passive: false, capture: true });
      document.addEventListener('touchmove', preventHandler, { passive: false, capture: true });
    }

    document.documentElement.dataset.facetDrawerScrollLocked = 'true';
  };

  const releaseLock = () => {
    const scrollY = parseInt(
      document.documentElement.dataset.facetDrawerScrollY || String(savedScrollY),
      10
    );

    document.documentElement.classList.remove(LOCK_CLASS, LOCKED_CLASS, MOBILE_OVERFLOW_CLASS);
    document.body.classList.remove(LOCK_CLASS, LOCKED_CLASS, MOBILE_OVERFLOW_CLASS);

    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('left');
    document.body.style.removeProperty('right');
    document.body.style.removeProperty('width');

    if (preventHandler) {
      document.removeEventListener('wheel', preventHandler, { capture: true });
      document.removeEventListener('touchmove', preventHandler, { capture: true });
      preventHandler = null;
    }

    delete document.documentElement.dataset.facetDrawerScrollLocked;
    delete document.documentElement.dataset.facetDrawerScrollY;

    // window.scrollTo(0, scrollY);
    removeHiddenHeaderClass();
    requestAnimationFrame(removeHiddenHeaderClass);
    window.setTimeout(removeHiddenHeaderClass, 450);
  };

  const syncFacetFiltersDrawerScrollLock = (shouldLock) => {
    const lock = shouldLock === true || (shouldLock !== false && isFacetFiltersDrawerOpen());
    const isLocked = document.documentElement.dataset.facetDrawerScrollLocked === 'true';

    if (lock) {
      if (!isLocked) {
        document.documentElement.dataset.facetDrawerScrollY = String(window.scrollY);
        applyLock();
      }
      return;
    }

    if (isLocked) releaseLock();
  };

  const bindDisclosure = (disclosure) => {
    if (!disclosure || disclosure.dataset.facetScrollLockBound === 'true') return;
    disclosure.dataset.facetScrollLockBound = 'true';
    new MutationObserver(() => syncFacetFiltersDrawerScrollLock()).observe(disclosure, {
      attributes: true,
      attributeFilter: ['open', 'class'],
    });
  };

  const initWatchers = () => {
    document
      .querySelectorAll('menu-drawer.mobile-facets__wrapper, .mobile-facets__wrapper')
      .forEach((wrapper) => bindDisclosure(wrapper.querySelector('.mobile-facets__disclosure')));

    const results = document.querySelector('.acs_collection_results, .acs_results');
    if (results) {
      new MutationObserver(() => {
        document
          .querySelectorAll('menu-drawer.mobile-facets__wrapper, .mobile-facets__wrapper')
          .forEach((wrapper) => bindDisclosure(wrapper.querySelector('.mobile-facets__disclosure')));
        if (isFacetFiltersDrawerOpen()) syncFacetFiltersDrawerScrollLock(true);
      }).observe(results, { childList: true, subtree: true });
    }
  };

  const lockOnFilterInteraction = (event) => {
    const target = event.target;
    if (!target?.closest) return;
    if (!target.closest('.acs_collection_results, .acs_results')) return;
    if (
      !target.matches('.mobile-facets__checkbox') &&
      !target.closest('.facets__label a, .mobile-facets__label a')
    ) {
      return;
    }
    syncFacetFiltersDrawerScrollLock(true);
  };

  window.isFacetFiltersDrawerOpen = isFacetFiltersDrawerOpen;
  window.syncFacetFiltersDrawerScrollLock = syncFacetFiltersDrawerScrollLock;

  document.addEventListener('change', lockOnFilterInteraction, true);
  document.addEventListener('click', lockOnFilterInteraction, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWatchers);
  } else {
    initWatchers();
  }
})();
